import { connect } from "react-redux";
import ShiftType from "../components/Shift/ShiftType";

const ShiftTypePage = ({ accessToken, currentLang }) => {
  return <ShiftType accessToken={accessToken} currentLang={currentLang} />;
};

function mapStateToProps({ auth, lang }) {
  return {
    auth,
    accessToken: auth.token.accessToken,
    currentLang: lang.currentLang,
  };
}

export default connect(mapStateToProps, null)(ShiftTypePage);
